import { useClenderEvents } from 'src/components/Conduct/SubjectTracking/VisitSchedule/useClenderEvents';
import { archLevel } from 'src/data/config';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setMessage } from 'src/store/Message';

export const useCalendarEventByVisitType = (visit_type: string) => {
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const dispatch = useAppDispatch();
  const { getMonitoringEvent } = useClenderEvents();

  const getMonitoringEventData = async () => {
    let dateOfSQVisit = '';
    const monitoringResponse: any = await getMonitoringEvent({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      visit_type,
      application: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
    });
    if (monitoringResponse.isSuccess) {
      dateOfSQVisit = monitoringResponse.data[0].start_date;
    } else if (monitoringResponse.isError) {
      if (monitoringResponse.error?.status === 500) {
        dispatch(
          setMessage({
            msgDetails: monitoringResponse.error?.message,
            severity: 'error'
          })
        );
      }
    }
    return dateOfSQVisit;
  };

  return { getMonitoringEventData };
};
